import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
function _createMdxContent(props) {
  const _components = {
    p: "p",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "حلبة كورنيش جدة هي موطن سباق الجائزة الكبرى السعودي للفورمولا 1 STC. تم افتتاحها لأول مرة في عام 2021، وتم بناء هذه المنشأة الرياضية العالمية في وقت قياسي بلغ سبعة أشهر فقط، لتكون الأولى من نوعها في المملكة، وقد تم تصميمها لتلبية المعايير المطلوبة من الاتحاد الدولي للسيارات (FIA) لاستضافة أحداث الفورمولا 1."
    }), "\n", _jsx("br", {}), "\n", _jsx(_components.p, {
      children: "تبلغ مسافة الحلبة، التي صممها المهندس تيليكه، 6.176 كيلومترًا، وهي الأسرع والأطول بين حلبات الشوارع في تقويم الفورمولا 1 الحالي. وتتميز بالكثير من المنعطفات السريعة - حيث تحتوي على 27 منعطفًا (16 يسارًا و11 يمينًا) - مما يجعلها مفضلة لدى السائقين والجماهير على حد سواء."
    }), "\n", _jsx("br", {}), "\n", _jsx(_components.p, {
      children: "حتى الآن، استضافت الحلبة أربعة عطلات نهاية أسبوع رائعة لسباقات الفورمولا 1، حيث شهدت كل منها فائزًا مختلفًا، مما رسخ مكانتها كأسرع حلبة شوارع في العالم، مع تسجيل السائقين لسرعات متوسطة تصل إلى 252 كم/ساعة."
    }), "\n", _jsx("br", {}), "\n", _jsx(_components.p, {
      children: "وقد أصبحت مجمعات المرافق الفاخرة للضيوف والمشجعين معروفة عالميًا، وأُعترف بالحلبة باعتبارها واحدة من أفضل البيئات التي توفر أعلى معايير الراحة والجودة لجميع العاملين والزوار."
    }), "\n", _jsx("br", {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
